__turbopack_context__.v({
  "container": "_7fjILq_container",
  "iframe": "_7fjILq_iframe",
  "loading": "_7fjILq_loading",
});
